/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { AgGridReact } from 'ag-grid-react';
import "../../CSS/general.css";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Axios from "axios";
import ColumnSelector from "../MainComponents/ColumnSelector";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import Cookies from 'js-cookie';
import moment from "moment";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import decryptParameter from "../../Helpers/DeCryptParameter";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavBar } from "../NavBar";
import { trim } from "lodash";
import AuthenticationContext from "../../Store/Authentication-Context";
import DefaultColumnSelector from "../MainComponents/DefaultColumnSelector";
import LoaderGif from "../../images/365 loading.gif"
import { setItem,getItem } from "../IndexedDBUtils";

const MasterAdmin = () => {
    const { setAuthContext } = useContext(AuthenticationContext);
    const { setBranding } = useContext(AuthenticationContext);
    const authContext = useContext(AuthenticationContext);
    const [activeTab, setActiveTab] = useState('operations');
    const [platformData, setPlatformData] = useState();
    const [guardianData, setGuardianData] = useState();
    const [rowData, setRowData] = useState();
    const [rowDataSelected, setRowDataSelected] = useState();
    ////const [managedOrgId, setManagedOrgId] = useState();
    ////const [managedOrgName, setManagedOrgName] = useState();
    const [operationFilter, setOperationFilter] = useState(null);
    const [platformFilter, setPlatformFilter] = useState(null);
    ////const [guardianFilter, setGuardianFilter] = useState(null);
    const [resellersData, setResellersData] = useState();
    const [priceModelsData, setPriceModelsData] = useState();
    const [orgStatuses, setOrgStatuses] = useState();
    const [sectors, setSectors] = useState();
    const [resellerFilter, setResellerFilter] = useState(null);
    const [tableRefresh, setTableRefresh] = useState(true);
    const [loaded, setloaded] = useState(false);
    const [modalBody, setModalBody] = useState('');
    const [showColumnSelector, setShowColumnSelector] = useState(true);
    ////const [selectedColumns, setSelectedColumns] = useState([]);
    const [companies, setCompanies] = useState(null);
    const [agreements, setAgreements] = useState(null);
    const [prevStage, setPrevStage] = useState("");
    const [jobEnableWarning, setJobEnableWarning] = useState(false);
    const handleColumnSelectorClose = (selectedColumns) => {

        ////setSelectedColumns(selectedColumns); 
        const json = JSON.stringify(selectedColumns);


        Cookies.set('selectedColumns', json);
        const updatedColumns = orgColumnDefs.map(column => ({
            ...column,
            hide: column.headerName !== "Options" &&  !selectedColumns.includes(column.field)
        }));

        setorgColumnDefs(updatedColumns);
    };
    const handleDefaultColumnSelector = (defaultTab) => {
        let defaultColumn = [];
        if (defaultTab === "Operations") {
            defaultColumn = ["resellerName",
                "orgName",
                "currentStatus",
                "nextAction",
                "creationDate",
                "trialUntil",
                "tennantDomain",
                "isReseller",
                "lastBackup",
                "warningCount",
                "disableAccess",
                "managed",
            ]
        }
        else if (defaultTab === "Finance") {
            defaultColumn = ["resellerName",
                "orgName",
                "trialUntil",
                "priceModel",
                "lastInvoice",
                "goCardlessID",
                "xeroID",
                "cwCompanyID",
                "cwAgreementID",
                "userCount",
                "spaceUsedGB"
            ]
        }
        else if (defaultTab === "Admin") {
            defaultColumn = ["resellerName",
                "orgName",
                "orgId",
                "nextAction",
                "salesSource",
                "adminEmail",
                "notificationEmail"
            ]
        }
     
        if (defaultTab !== "") {
       
            ////setSelectedColumns(defaultColumn);
            const json = JSON.stringify(defaultColumn);
        

            Cookies.set('selectedColumns', json);
            const updatedColumns = orgColumnDefs.map(column => ({
                ...column,
                hide: column.headerName !== "Options" && !defaultColumn.includes(column.field)
            }));
            handleColumnSelectorClose(defaultColumn)
            setorgColumnDefs(updatedColumns);
        }
    };
    

    useEffect(() => {
        setBranding(sessionStorage.getItem("orgId"), sessionStorage.getItem("orgName"));
        if (decryptParameter(sessionStorage.getItem("ResellerID")) !== "1") {
            
            window.location.href =   "/login";
        }
      

        setloaded(true);
        let columnsToIncluded = [];
        const storedSelectedColumns = Cookies.get('selectedColumns');
        if (storedSelectedColumns) {
            columnsToIncluded = JSON.parse(storedSelectedColumns);


        }
        else {
            columnsToIncluded =["resellerName",
                "orgName",
                "currentStatus",
                "nextAction",
                "creationDate",
                "trialUntil",
                "tennantDomain",
                "isReseller",
                "lastBackup",
                "warningCount",
                "disableAccess",
                "managed",
                "sector"
            ]
        }
        const updatedColumns = orgColumnDefs.map(column => ({
            ...column,
            hide: column.headerName !== "Options" && !columnsToIncluded.includes(column.field)
        }));

        setorgColumnDefs(updatedColumns);
    }, []);


    //const [isOperationOrgValid, setIsOperationOrgValid] = useState(true);
    //const [operationOrgErrorMessage, setOperationOrgErrorMessage] = useState("Invalid")
    const [validation, setValidation] = useState({
        isOrgValid: true,
        orgErrorMessage: "",
        isGoCardlessValid: true,
        goCardLessErrorMessage: "",
        isXeroIdValid: true,
        xeroIdErrorMessage: "",
        isCwCompanyIdValid: true,
        cwCompanyIdErrorMessage: "",
        isCwAggreementIdValid: true,
        cwAggreementIdErrorMessage: "",
        
        isSalesSourceValid: true,
        salesSourceErrorMessage: "",

        isSectorValid: true,
        sectorErrorMessage: "",

        isResellerNameValid: true,
        resellerNameErrorMessage: "",
        //isStageValid: false,
        isTelephoneNumberValid: true,
        telephoneNumberErrorMessage: "",
        isPortalUrlValid: true,
        portalUrlErrorMessage: "",
        isResellerTenantValid: true,
        resellerTenantErrorMessage: "",
        isOrgIdValid: true,
        orgIdErrorMessage: "",
        isServerPathValid: true,
        ServerPathErrorMessage: "",
        isResellerEmailValid: true,
        isAdminEmailValid: true,
        adminEmailErrorMessage: "",
        isNotificationEmailValid: true,
        notificationEmailErrorMessage: "",
        resellerEmailErrorMessage: "",
        isTrialDateValid: true,
        trailDateErrorMessage: "",
        isNextActionDateValid: true,
        nextActionDateErrorMessage: "",
    });
    const handleTabSelect = (eventKey) => {

        setActiveTab(eventKey);
        if (eventKey === "operations") {
            setShowColumnSelector(true);
        }
        else {
            setShowColumnSelector(false);
        }
        setRowDataSelected(null);
    };

    const [show, setShow] = useState(false);
    const [showTenantSummary, setShowTenantSummary] = useState(false);
    const [tenantSummaryURL, setTenantSummaryURL] = useState("");
    const activeTabRef = useRef(activeTab);


    const showToast = (type, message) => {
        if (type === "success") {
            toast.success(message, {
                position: 'top-right',
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
            });
        }
        else if (type === "error") {

            toast.error('! ' + message, {
                position: 'top-right',
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: false,
                closeButton: true, // Include a close button
                style: {
                    color: 'red' // Set the color to red
                },
                autoClose: true

            });
        }
    };
    const dateFormatter = (params) => {
        
        if (params.value === "0001-01-01T00:00:00") {
            return "";
        }

        if (params.value)
            return moment(params.value, 'DD/MM/YYYY').format("DD-MM-YYYY").toString();
        else
            return params.value;
    };

    const dateFormatterForUTC = (params) => {
        
        if (params.value === "0001-01-01T00:00:00") {
            return "";
        }
        if (params.value ) {
            // Use moment.js to parse and format the date
            const formattedDate = moment(params.value, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS').format("DD-MM-YYYY:HH:mm");
            return formattedDate;
        } else {
            return ""; // or return params.value depending on your requirement
        }
    };
    const dateFilterParams = {
        comparator: function (filterLocalDateAtMidnight, cellValue) {
            // If the cellValue is not available, consider it out of range.
            if (!cellValue) {
                return false; // Treat as invalid for all conditions.
            }

            // Parse the cell value, focusing on the date portion.
            const cellDate = moment(cellValue, 'YYYY-MM-DD').startOf('day');
                 
            // Exclude records where the date is '01-01-0001'.
            const invalidDate = moment('01-01-0001', 'DD-MM-YYYY').startOf('day');
            if (cellDate.isSame(invalidDate, 'day')) {
                return false; // Return null to exclude this date for all filter conditions.
            }
           
           
            const filterDate = moment(filterLocalDateAtMidnight, 'DD-MM-YYYY').startOf('day');
           // console.log(filterDate, normalizedCellDate, normalizedCellDate.isSame(filterDate, 'day'), normalizedCellDate.isBefore(filterDate, 'day'), normalizedCellDate.isAfter(filterDate, 'day'));
            if (cellDate.isSame(filterDate, 'day')) {
                return 0; // cell date is before the filter date.
            }
            // Compare the dates directly for all filter conditions.
            else if (cellDate.isBefore(filterDate, 'day')) {
                return -1; // cell date is before the filter date.
            } else if (cellDate.isAfter(filterDate, 'day')) {
                return 1; // cell date is after the filter date.
            }
           
        },
        browserDatePicker: true,
        filterOptions: ['inRange', 'lessThan', 'greaterThan', 'equals'],
    };



    const renderTooltip = (props) => (

        <Tooltip id={`tooltip-${props.id}`} {...props}>
            {props.text}
        </Tooltip>

    );

    const trialUntilRenderer = (params) => {
        const trialUntilDate = params.data.trialUntil;
        const creationDate = params.data.creationDate;
        const diffInDays = moment(trialUntilDate, 'DD-MM-YYYY').diff(moment(creationDate, 'DD-MM-YYYY'), 'days');

        
        if (diffInDays > 14) {
            return <span style={{ color: 'red' }} > {trialUntilDate}</ span>;
        }
        else {
            return trialUntilDate
        }       
    };

    const proxyStatusRenderer = (params) => {
        const proxyStatus = params.data.proxyStatus;
      
        if (proxyStatus !=="Online") {
            return <span style={{ color: 'red' }} > {proxyStatus}</ span>;
        }
        else {
            return proxyStatus
        }
    };

    const jobStatusRenderer = (params) => {
        const jobStatus = params.data.lastStatus;

        if (jobStatus === "Warning") {
            return <span style={{ color: 'orange' }} > {jobStatus}</ span>;
        }
        if (jobStatus === "Success") {
            return <span style={{ color: 'green' }} > {jobStatus}</ span>;
        }
        if (jobStatus === "Failed") {
            return <span style={{ color: 'red' }} > {jobStatus}</ span>;
        }
        else {
            return jobStatus
        }
    };

    
    const platformDefs = [
        {
            headerName: 'Options', width: 100,
            cellRenderer: (params) => {


                return (
                    <div className="justify-content-between d-flex align-items-center">
                        {params.data.orgId &&
                            <button onClick={() => manageOrg(params)} className={(sessionStorage.getItem('UserType') === 'busadmin a-icon' && params.data.currentStatus?.toLowerCase() !== 'demo') ? 'disabled-link a-icon' : 'a-icon'}
                                style={(sessionStorage.getItem('UserType') === 'busadmin' && params.data.currentStatus?.toLowerCase() !== 'demo') ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                            >
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Manage Organisation" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
                                        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                                        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                        }
                    </div>
                );
            }
        },
        {
            headerName: 'Reseller Name', field: 'resellerName', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Tenant', field: 'orgName', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Job Name', field: 'name', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Job Status', field: 'lastStatus', sortable: true, filter: true, width: 150, resizable: true, cellRenderer: (params) => {
                return jobStatusRenderer(params)
            } ,comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Last Success', field: 'lastBackup', sortable: true, width: 200, valueFormatter: dateFormatterForUTC, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }
           
                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
                //return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }, filter: 'agDateColumnFilter',
            filterParams: dateFilterParams,
        },
        {
            headerName: 'Next Run', field: 'nextRun', sortable: true, width: 200, valueFormatter: dateFormatterForUTC, getQuickFilterText: params => {
                return dateFormatterForUTC(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
            }, filter: 'agDateColumnFilter',
        filterParams: dateFilterParams,
        },
        {
            headerName: 'Repository', field: 'repositoryName', sortable: true, filter: true, width: 300, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: '', width: 60,
            cellRenderer: (params) => {
                const canDelete = params.data.repositoryDeletionDate && params.data.repositoryDeletionDate !== '' && moment(params.data.repositoryDeletionDate, 'DD-MM-YYYY').isBefore(moment());
               
                return (
                    <div className="justify-content-between d-flex align-items-center">
                        {canDelete &&

                            <button className='a-icon' onClick={() => deleteRepo(params)}
                               
                            >
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Delete Repository Backup" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                        }
                    </div>
                );
            }
        },

        {
            headerName: 'Repository Description', field: 'repositoryDescription', sortable: true, filter: true, width:200 , resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        
        {
            headerName: 'Repository Deletion', field: 'repositoryDeletionDate', sortable: true, filter: true, width: 200, resizable: true, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null || date1==='') {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null || date2 === '') {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }
              
                return moment(date1, 'DD-MM-YYYY').diff(moment(date2, 'DD-MM-YYYY'));
            },
        },
        {
            headerName: 'InSync', field: 'inSync', sortable: true, filter: true, width: 100, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Proxy Name', field: 'proxyName', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Proxy Status', field: 'proxyStatus', sortable: true, filter: true, width: 150, resizable: true, cellRenderer: (params) => {
                return proxyStatusRenderer(params)
            }, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Object Endpoint', field: 'objectEndPoint', sortable: true, filter: true, width: 300, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Space Used', field: 'spaceUsed', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Immutable', field: 'immutable', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
       
    ];

    const guardianDefs = [
        
        {
            headerName: 'Job Id', field: 'jobID', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Convert to integers (parseInt), handling null/empty
                const numA = parseInt(valueA, 10);
                const numB = parseInt(valueB, 10);

                // Handle NaN (e.g., non-numeric or empty)
                const isNumAValid = !isNaN(numA);
                const isNumBValid = !isNaN(numB);

                if (!isNumAValid && !isNumBValid) return 0;
                if (!isNumAValid) return -1;
                if (!isNumBValid) return 1;

                return numA - numB;
            }
        },
        {
            headerName: 'Tenant', field: 'tenantID', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Job Name', field: 'name', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Job Description', field: 'description', sortable: true, filter: true, width: 150, resizable: true,  comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Job Type', field: 'jobType', sortable: true, width: 150, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
           
        },
        {
            headerName: 'Next Run', field: 'nextRun', sortable: true, width: 200, valueFormatter: dateFormatterForUTC, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
                //return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }, filter: 'agDateColumnFilter',
            filterParams: dateFilterParams,
        },
        {
            headerName: 'Last Run', field: 'lastRun', sortable: true, width: 200, valueFormatter: dateFormatterForUTC, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ').diff(moment(date2, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ'));
                //return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }, filter: 'agDateColumnFilter',
            filterParams: dateFilterParams,
        },
        {
            headerName: 'Attempt', field: 'attempt', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Convert to integers (parseInt), handling null/empty
                const numA = parseInt(valueA, 10);
                const numB = parseInt(valueB, 10);

                // Handle NaN (e.g., non-numeric or empty)
                const isNumAValid = !isNaN(numA);
                const isNumBValid = !isNaN(numB);

                if (!isNumAValid && !isNumBValid) return 0;
                if (!isNumAValid) return -1;
                if (!isNumBValid) return 1;

                return numA - numB;
            }
        },
        {
            headerName: 'Status', field: 'status', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Active', field: 'active', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if ((valueA || valueA.trim() === '') && (valueB || valueB.trim() === '')) {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: '', width: 60,
            cellRenderer: (params) => {
                const renderEyeIcon = params.data.lastMessage && params.data.lastMessage !== '' ;

                return (
                    <div className="justify-content-between d-flex align-items-center">
                        {renderEyeIcon && (
                            <OverlayTrigger
                                key="sort-1"
                                placement="top"
                                delay={{ show: 50, hide: 50 }}
                                overlay={(props) =>
                                    renderTooltip({
                                        ...props,
                                        id: "sort-1",
                                        text: params.data.lastMessage
                                    })
                                }
                            >
                                <div style={{ cursor: "default" }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-eye"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                    </svg>
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>
                );
            }
        },

        
    ];
    const isVeeam365AdminSales = sessionStorage.getItem("IsVeeam365AdminSales") === "true";
    const isVeeam365Admin = sessionStorage.getItem("IsVeeam365Admin") === "true";
    const isVeeam365Engineer = sessionStorage.getItem("IsVeeam365Engineer") === "true";
    const serviceProvider = sessionStorage.getItem("ServiceProvider") === "true";
    const [orgColumnDefs, setorgColumnDefs] = useState([
        {
            headerName: 'Options', width: 170,
            cellRenderer: (params) => {
                const currentStatus = params.data.currentStatus === 'DEMO';
                const disableForSalesUsers = !((isVeeam365AdminSales && !isVeeam365Admin && currentStatus) || (isVeeam365Admin) || (isVeeam365Engineer) || (serviceProvider));
                return (
                    <div className="justify-content-between d-flex align-items-center">

                        <button className='a-icon' onClick={disableForSalesUsers ? null : () => handleShow(params)} style={disableForSalesUsers ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Edit Customer" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                </svg>
                            </OverlayTrigger>
                        </button>
                        <button className='a-icon' onClick={disableForSalesUsers ? null : () => suspendOrg(params)} style={disableForSalesUsers ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Disable Access" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pause-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                                </svg>
                            </OverlayTrigger>
                        </button>

                        <button className='a-icon' onClick={disableForSalesUsers ? null : () => activateOrg(params)} style={disableForSalesUsers ? { pointerEvents: 'none', opacity: 0.5 } : {}} >
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Enable Access" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-play-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                                </svg>
                            </OverlayTrigger>
                        </button>

                        <button className='a-icon' onClick={disableForSalesUsers ? null : () => deleteOrg(params)} style={disableForSalesUsers ? { pointerEvents: 'none', opacity: 0.5 } : {}}  >
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Remove Tenant" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                </svg>
                            </OverlayTrigger>
                        </button>

                        {params.data.isReseller ? <button className='a-icon' style={{ cursor: 'not-allowed' }}>

                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Already a Reseller" })}>

                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">

                                    <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5" />

                                </svg>

                            </OverlayTrigger>

                        </button> : <button className='a-icon' onClick={disableForSalesUsers ? null : () => convertToReseller(params)} style={disableForSalesUsers ? { pointerEvents: 'none', opacity: 0.5 } : {}} >

                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Convert to Reseller" })}>

                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right" viewBox="0 0 16 16">

                                    <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5" />

                                </svg>


                            </OverlayTrigger>

                        </button>}
                        <button className='a-icon' onClick={() => handleTenantSummary(params)}>
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "View Tenant Summary" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                </svg>
                            </OverlayTrigger>
                            
                        </button>

                        <button
                            onClick={disableForSalesUsers ? null : () => manageOrg(params)} className={`${disableForSalesUsers ? 'disabled-link a-icon' : 'a-icon'} ${sessionStorage.getItem('UserType') === 'busadmin' && params.data.currentStatus?.toLowerCase() !== 'demo' ? 'disabled-link' : ''}`}
                            style={{
                                pointerEvents: (sessionStorage.getItem('UserType') === 'busadmin' && params.data.currentStatus?.toLowerCase() !== 'demo') || disableForSalesUsers ? 'none' : 'auto',
                                opacity: (sessionStorage.getItem('UserType') === 'busadmin' && params.data.currentStatus?.toLowerCase() !== 'demo') || disableForSalesUsers ? 0.5 : 1
                            }}>
                                    <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Manage Organisation" })}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
                                            <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                                            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                                        </svg>
                                    </OverlayTrigger>
                                </button>
                        
                    </div>
                );
            },
        },
        {
            headerName: 'Reseller Name', field: 'resellerName', sortable: true, filter: true, width: 250, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },

        {
            headerName: 'Organisation Name', field: 'orgName', sortable: true, filter: true, width: 300, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },// Operation finance


        {
            headerName: 'Stage', field: 'currentStatus', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },// Operation finance Admin
        {
            headerName: 'Next Action', field: 'nextAction', sortable: true, filter: true, width: 150, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Admin

        {
            headerName: 'Package', field: 'priceModel', width: 250, sortable: true, filter: true, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Finance
        {
            headerName: 'Date Created', field: 'creationDate', sortable: true, filter: true, width: 150, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            },
        },//operation

        {
            headerName: 'Trial Date', field: 'trialUntil', sortable: true, filter: true, width: 170, valueFormatter: dateFormatter, getQuickFilterText: params => {
                dateFormatter(params);
            }, cellRenderer: (params) => {
                return trialUntilRenderer(params)
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            },
        },// Operation finance

        { headerName: 'Last Inv', field: 'lastInvoice', width: 100, sortable: true, filter: true, resizable: true },//Finance 
        {
            headerName: 'GoCardless ID', field: 'goCardlessID', width: 200, sortable: true, filter: true, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Finance 
        {
            headerName: 'Tenant Domain', field: 'tennantDomain', sortable: true, filter: true, width: 250, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//operation
        {
            headerName: 'Xero ID', field: 'xeroID', width: 150, sortable: true, filter: true, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Finance

        {
            headerName: 'CWCompanyID', field: 'cwCompanyID', width: 100, sortable: true, filter: true, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Finance

        {
            headerName: 'CWAgreementID', field: 'cwAgreementID', width: 100, sortable: true, filter: true, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Finance 

        { headerName: 'Users', field: 'userCount', sortable: true, filter: true, width: 95, resizable: true },//Finance 
        { headerName: 'GB', field: 'spaceUsedGB', sortable: true, filter: true, width: 95, resizable: true },//Finance 
        { headerName: 'Org ID', field: 'orgId', sortable: true, filter: true, width: 350, resizable: true },//Reseller Admin
        {
            headerName: 'Next Action Date', field: 'nextActionDate', width: 200, sortable: true, filter: true, resizable: true, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            },
        },//Admin
        {
            headerName: 'Sales Source', field: 'salesSource', sortable: true, filter: true, width: 350, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Admin
        {
            headerName: 'Admin Email', field: 'adminEmail', sortable: true, filter: true, width: 350, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Admin
        {
            headerName: 'Support Contact', field: 'notificationEmail', sortable: true, filter: true, width: 350, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Admin
        { headerName: 'Reseller', field: 'isReseller', sortable: true, width: 100, filter: true, cellDataType: false,valueFormatter: params => params.value?.toString() },//operation

        {
            headerName: '365 Last Run', field: 'lastBackup', sortable: true, filter: true, width: 170, valueFormatter: dateFormatter, getQuickFilterText: params => {
                return dateFormatter(params);
            }, comparator: function (date1, date2) {
                // Custom comparator function for datetime sorting
                if (date1 === undefined || date1 === null) {
                    // Treat undefined or null as greater than any defined date
                    return 1;
                }
                if (date2 === undefined || date2 === null) {
                    // Treat undefined or null as greater than any defined date
                    return -1;
                }

                return moment(date1, 'DD/MM/YYYY').diff(moment(date2, 'DD/MM/YYYY'));
            }, cellRenderer: function (params) {

                // Check if JobStatus exists and its value
                if ((params.data.lastBackup)) {
                    return dateFormatter(params);
                }
                else {
                    return '<div class="pt-1"><svg width="25" height="25" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class=" m-1 ms-3"> < circle cx = "15" cy = "50" r = "10" fill = "curren<animate attributeName="cy" values="50;5;50" dur="1s" repeatCount="indefinite" begin="0s"></animate></circle ><circle cx="50" cy="50" r="10" fill="currentColor"><animate attributeName="cy" values="50;5;50" dur="1s" repeatCount="indefinite" begin="0.2s"></animate></circle><circle cx="85" cy="50" r="10" fill="currentColor"><animate attributeName="cy" values="50;5;50" dur="1s" repeatCount="indefinite" begin="0.4s"></animate></circle></svg ></div>';
                }
            }
        },//operation
        {
            headerName: '365 Status',
            field: 'warningCount',
            sortable: true,
            width: 120,
            filter: true,
            cellRenderer: (params) => {
                const { data } = params;

                if (data?.lastBackupStatus) {
                    const commonSpanStyle = {
                        padding: '0 9px',
                        color: 'white',
                        fontSize: '14px',
                        borderRadius: '5px',
                    };

                    switch (data.lastBackupStatus) {
                        case 'Red':
                            return (
                                <div className="pt-1" title={data.warningSplitUpMsg}>
                                    <span
                                        className="m-1 ms-3"
                                        style={{ ...commonSpanStyle, background: 'red' }}
                                    >
                                        {data.warningCount}
                                    </span>
                                </div>
                            );

                        case 'Black':
                            return (
                                <div className="pt-1" title={data.warningSplitUpMsg}>
                                    <span
                                        className="m-1 ms-3"
                                        style={{ ...commonSpanStyle, background: 'black' }}
                                    >
                                        {data.warningCount}
                                    </span>
                                </div>
                            );

                        case 'Green':
                            return (
                                <div className="pt-1">
                                    <span
                                        className="m-1 ms-3"
                                        style={{ ...commonSpanStyle, background: 'green' }}
                                    >
                                        {data.warningCount}
                                    </span>
                                </div>
                            );

                        case 'Amber':
                            return (
                                <div className="pt-1" title={data.warningSplitUpMsg}>
                                    <span
                                        className="m-1 ms-3"
                                        style={{ ...commonSpanStyle, background: 'orange' }}
                                    >
                                        {data.warningCount}
                                    </span>
                                </div>
                            );

                        case 'Running':
                            return (
                                <div className="pt-1">
                                    <div className="vector-runing-icon"></div>
                                </div>
                            );

                        default:
                            return <span>{data.lastBackupStatus}</span>;
                    }
                }

                // Spinner when lastBackupStatus is not available
                return (
                    <div className="pt-1">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 100 100"
                            xmlns="http://www.w3.org/2000/svg"
                            className="m-1 ms-3"
                            fill="currentColor"
                        >
                            <circle cx="15" cy="50" r="10">
                                <animate
                                    attributeName="cy"
                                    values="50;5;50"
                                    dur="1s"
                                    repeatCount="indefinite"
                                    begin="0s"
                                />
                            </circle>
                            <circle cx="50" cy="50" r="10">
                                <animate
                                    attributeName="cy"
                                    values="50;5;50"
                                    dur="1s"
                                    repeatCount="indefinite"
                                    begin="0.2s"
                                />
                            </circle>
                            <circle cx="85" cy="50" r="10">
                                <animate
                                    attributeName="cy"
                                    values="50;5;50"
                                    dur="1s"
                                    repeatCount="indefinite"
                                    begin="0.4s"
                                />
                            </circle>
                        </svg>
                    </div>
                );
            },
            comparator: function (valueA, valueB,nodeA,nodeB) {
                const order = ['Black', 'Green', 'Running', 'Amber', 'Red'];

                // Get the index of each value in the order array
                const indexA = order.indexOf(nodeA.data.lastBackupStatus);
                const indexB = order.indexOf(nodeB.data.lastBackupStatus);

                // Compare the indexes
                if (indexA === indexB) {
                    return 0;
                } else if (indexA === -1) {
                    // If valueA is not found in the order array, place it at the end
                    return 1;
                } else if (indexB === -1) {
                    // If valueB is not found in the order array, place it at the end
                    return -1;
                } else {
                    // Compare indexes directly
                    return indexA - indexB;
                }
            }
        },
        {
            headerName: 'Managed',
            field: 'managed',
            sortable: true,
            cellRenderer: (params) => {

                return (
                    <input
                        type="checkbox"
                        checked={params.data.managed}

                        disabled={true}
                    />
                );
            }, width: 100
        },
        {
            headerName: 'Sector', sortable: true, filter: true, resizable: true,
            field: 'sector',
            width: 150,
            cellRenderer: (params) => {


                return (
                    <div className="justify-content-between d-flex align-items-center">
                        {params.data.orgId &&
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: params.value})}>
                                    <div>{params.value}</div>
                                </OverlayTrigger>
                        }
                    </div>
                );
            }
        }

    ]);

    const resellerDefs = [
        {
            headerName: 'Options', resizable: true, width: 100,
            cellRenderer: (params) => {
                const disableResellerIcon = isVeeam365AdminSales && !isVeeam365Admin && !isVeeam365Engineer && !serviceProvider;
                return (
                    <div className="justify-content-around d-flex align-items-center">
                        <button className='a-icon' onClick={disableResellerIcon ? null : () => handleShow(params)}
                            style={{
                                pointerEvents: disableResellerIcon ? 'none' : 'auto',
                                opacity: disableResellerIcon ? 0.5 : 1,
                            }}>
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Edit Reseller" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                </svg>
                            </OverlayTrigger>
                        </button>
                        <button className='a-icon' onClick={disableResellerIcon ? null : () => deleteReseller(params)}
                            style={{
                                pointerEvents: disableResellerIcon ? 'none' : 'auto',
                                opacity: disableResellerIcon ? 0.5 : 1,
                            }}>

                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Delete Reseller" })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                </svg>
                            </OverlayTrigger>
                        </button>

                    </div>
                );
            },
        },
        {
            headerName: 'Reseller Name', field: 'resellerName', sortable: true, filter: true, width: 350, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        { headerName: 'Reseller Id', field: 'resellerId', sortable: true, filter: true, width: 175, resizable: true },//Resellerid
        { headerName: 'Telephone No', field: 'resellerTelNo', sortable: true, filter: true, width: 175, resizable: true },//Reseller
        
        {
            headerName: 'Portal URL', field: 'resellerURL', sortable: true, filter: true, width: 350, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Reseller
        {
            headerName: 'Server Path', field: 'serverPath', sortable: true, filter: true, width: 350, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Reselle
        {
            headerName: 'Reseller Tenant', field: 'tenentName', sortable: true, filter: true, width: 300, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },//Reseller

        { headerName: 'Org ID', field: 'orgID', sortable: true, filter: true, width: 350, resizable: true },//Reseller
        { headerName: 'Package', field: 'priceModelName', sortable: true, filter: true, width: 250, resizable: true },//Reseller
        {
            headerName: 'Email', field: 'resellerEmail', sortable: true, filter: true, width: 260, resizable: true, comparator: function (valueA, valueB) {
                // Handle null values
                if (valueA == null && valueB == null) {
                    return 0;
                }
                if (valueA == null) {
                    return -1;
                }
                if (valueB == null) {
                    return 1;
                }

                // Handle empty values
                if (valueA.trim() === '' && valueB.trim() === '') {
                    return 0;
                }
                if (valueA.trim() === '') {
                    return -1;
                }
                if (valueB.trim() === '') {
                    return 1;
                }

                // Compare non-null and non-empty values
                const normalizedA = valueA.toLowerCase();
                const normalizedB = valueB.toLowerCase();

                if (normalizedA < normalizedB) {
                    return -1;
                }
                if (normalizedA > normalizedB) {
                    return 1;
                }
                return 0;
            }
        },
        {
            headerName: 'Custom Models Only', field: 'customModelsOnly', sortable: true,
            cellRenderer: (params) => {

                return (
                    <input
                        type="checkbox"
                        checked={params.data.customModelsOnly}

                        disabled={true}
                    />
                );
            },filter: true, width: 100, resizable: true }
       
    ];
    const resellerChangeinReseller = (params) => {


        params.persist()

        setRowDataSelected({ ...rowDataSelected, resellerName: params.target.value });
        if (params.target.value !== "" && params.target.value.length < 50) {


            setValidation({
                ...validation,
                isResellerNameValid: true,
                resellerNameErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isResellerNameValid: false,
                    resellerNameErrorMessage: "Reseller Name should not be Empty"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isResellerNameValid: false,
                    resellerNameErrorMessage: "Reseller Name Should not be more than 50 character "
                });
            }
        }

    }
    const resellerChange = (params) => {
        params.persist()
        setRowDataSelected({ ...rowDataSelected, resellerName: params.target.value });
        //const selectedName = params.target.value;
        //const selectedReseller = resellersData.find(r => r.resellerName === selectedName);

        //setRowDataSelected({
        //    ...rowDataSelected,resellerName: selectedName,
        //    resellerId: selectedReseller?.resellerId,
        //});
    };

    const orgChange = (params) => {

        setRowDataSelected({ ...rowDataSelected, orgName: params.target.value });
        if (params.target.value !== "" && params.target.value.length < 200) {


            setValidation({
                ...validation,
                isOrgValid: true,
                orgErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isOrgValid: false,
                    orgErrorMessage: "Organization Name should not be Empty"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isOrgValid: false,
                    orgErrorMessage: "Organization Name Should not be more than 200 character "
                });
            }
        }
    }

    const nextActionChange = (params) => {

        setRowDataSelected({
            ...rowDataSelected,


            nextAction: params.target.value
        });


    }
    const saleChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            salesSource: params.target.value
        });

        if (params.target.value.length < 50) {
            setValidation({
                ...validation,
                isSalesSourceValid: true,
                salesSourceErrorMessage: ""
            });
        }
        else {
            setValidation({
                ...validation,
                isSalesSourceValid: false,
                salesSourceErrorMessage: "Sales Source Should not be more than 50 character "
            });
        }
    }

    const trailDateChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            trialUntil: moment(params.target.value, "YYYY-MM-DD").format("DD-MM-YYYY")
        });
        if (params.target.value !== "") {
            setValidation({
                ...validation,
                isTrialDateValid: true,
                trailDateErrorMessage: ""
            });
        }
        else {
            setValidation({
                ...validation,
                isTrialDateValid: false,
                trailDateErrorMessage: "Trial Date Should Not Be Empty"
            });
        }
        
    }
    const nextActionDateChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            nextActionDate: moment(params.target.value, "YYYY-MM-DD").format("DD-MM-YYYY")
        });
        if (params.target.value !== "") {
            setValidation({
                ...validation,
                isNextActionDateValid: true,
                nextActionDateErrorMessage: ""
            });
        }
        else {
            setValidation({
                ...validation,
                isNextActionDateValid: false,
                nextActionDateErrorMessage: "Next Action Date Should Not Be Empty"
            });
        }

    }
    const priceModelChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,


            priceModel: params.target.value

        });

    }

    const goCardlessIDChange = (params) => {

        setRowDataSelected({
            ...rowDataSelected,
            goCardlessID: params.target.value
        });
        if (params.target.value.length < 50) {
            setValidation({
                ...validation,
                isGoCardlessValid: true,
                orgErrorMessage: ""
            });
        }
        else {
            setValidation({
                ...validation,
                isGoCardlessValid: false,
                goCardLessErrorMessage: "GoCardLess Id Should not be more than 50 character"
            });
        }
    }

    const xeroIDChange = (params) => {

        setRowDataSelected({
            ...rowDataSelected,
            xeroID: params.target.value
        });
        if (params.target.value.length < 50) {
            setValidation({
                ...validation,
                isXeroIdValid: true,
                xeroIdErrorMessage: ""
            });
        }
        else {
            setValidation({
                ...validation,
                isXeroIdValid: false,
                xeroIdErrorMessage: "Xero Id Should not be more than 50 character"
            });
        }

    }
    const cwCompanyIDChange = (params) => {
            setRowDataSelected({
                ...rowDataSelected,
                cwCompanyID: Number(params.target.value)
            });
            
        }
    

    const cwAggreementIDChange = (params) => {

        setRowDataSelected({
            ...rowDataSelected,
            cwAgreementID: params.target.value
        });


    }
    const telphoneChange = (params) => {

        setRowDataSelected({
            ...rowDataSelected,
            resellerTelNo: params.target.value
        });
        if (params.target.value !== "" && params.target.value.length < 15 && /^\d*$/.test(params.target.value)) {

            setValidation({
                ...validation,
                isTelephoneNumberValid: true,
                telephoneNumberErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isTelephoneNumberValid: false,
                    telephoneNumberErrorMessage: "Telephone Number should not be Empty"
                });
            }
            else if (!/^\d*$/.test(params.target.value)) {
                setValidation({
                    ...validation,
                    isTelephoneNumberValid: false,
                    telephoneNumberErrorMessage: "Telephone Number Should not contain alphabet "
                });
            }
            else {
                setValidation({
                    ...validation,
                    isTelephoneNumberValid: false,
                    telephoneNumberErrorMessage: "Telephone Number Should not be more than 15 character "
                });
            }
        }
    }

    const resellerURLChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            resellerURL: params.target.value
        });
        if (params.target.value !== "" && params.target.value.length < 50) {
            setValidation({
                ...validation,
                isPortalUrlValid: true,
                portalUrlErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isPortalUrlValid: false,
                    portalUrlErrorMessage: "Portal URL should not be Empty"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isPortalUrlValid: false,
                    portalUrlErrorMessage: "Portal URL Should not be more than 50 character "
                });
            }
        }
    }

    const tennantDomainChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            tenentName: params.target.value
        });
        if (params.target.value !== "" && params.target.value.length < 50) {
            setValidation({
                ...validation,
                isResellerTenantValid: true,
                resellerTenantErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isResellerTenantValid: false,
                    resellerTenantErrorMessage: "Reseller Tenant should not be Empty"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isResellerTenantValid: false,
                    resellerTenantErrorMessage: "Reseller Tenant Should not be more than 50 character "
                });
            }
        }
    }

    const resellerOrgIdChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            orgID: params.target.value
        });
        if (params.target.value !== "" && params.target.value.length < 38) {
            setValidation({
                ...validation,
                isOrgIdValid: true,
                orgIdErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isOrgIdValid: false,
                    orgIdErrorMessage: "Organization Id should not be Empty"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isOrgIdValid: false,
                    orgIdErrorMessage: "Organization Id Should not be more than 38 character "
                });
            }
        }
    }
    const resellerPriceModelChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            priceModelName: params.target.value

        });
    }
    const customModelsOnly = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            customModelsOnly: params.target.checked
        });
    }
    const serverPathChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            serverPath: params.target.value
        });
        if (params.target.value !== "") {
            setValidation({
                ...validation,
                isServerPathValid: true,
                ServerPathErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isServerPathValid: false,
                    ServerPathErrorMessage: "Server Path should not be Empty"
                });
            }
          
        }
    }

    const resellerEmailChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            resellerEmail: params.target.value
        });
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (params.target.value !== "" && params.target.value.length < 50 && emailPattern.test(params.target.value)) {
            setValidation({
                ...validation,
                isResellerEmailValid: true,
                resellerEmailErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isResellerEmailValid: false,
                    resellerEmailErrorMessage: "Email should not be Empty"
                });
            }
            else if (!emailPattern.test(params.target.value)) {
                setValidation({
                    ...validation,
                    isResellerEmailValid: false,
                    resellerEmailErrorMessage: "Enter a valid email address"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isResellerEmailValid: false,
                    resellerEmailErrorMessage: "Email Should not be more than 50 character "
                });
            }
        }
    }

    const adminEmailChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            adminEmail: params.target.value
        });
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (params.target.value !== "" && params.target.value.length < 50 && emailPattern.test(params.target.value)) {
            setValidation({
                ...validation,
                isAdminEmailValid: true,
                adminEmailErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isAdminEmailValid: false,
                    adminEmailErrorMessage: "Admin Email should not be Empty"
                });
            }
            else if (!emailPattern.test(params.target.value)) {
                setValidation({
                    ...validation,
                    isAdminEmailValid: false,
                    adminEmailErrorMessage: "Enter a valid Admin email address"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isAdminEmailValid: false,
                    adminEmailErrorMessage: "Admin Email Should not be more than 50 character "
                });
            }
        }
    }

    const sectorChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            sector: params.target.value
        });

        if (params.target.value.length < 250) {
            setValidation({
                ...validation,
                isSectorValid: true,
                sectorErrorMessage: ""
            });
        }
        else {
            setValidation({
                ...validation,
                isSectorValid: false,
                sectorErrorMessage: "Sector Should not be more than 250 character "
            });
        }
    }


    const notificationEmailChange = (params) => {
        setRowDataSelected({
            ...rowDataSelected,
            notificationEmail: params.target.value
        });
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (params.target.value !== "" && params.target.value.length < 50 && emailPattern.test(params.target.value)) {
            setValidation({
                ...validation,
                isNotificationEmailValid: true,
                notificationEmailErrorMessage: ""
            });
        }
        else {
            if (params.target.value === "") {
                setValidation({
                    ...validation,
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Notification Email should not be Empty"
                });
            }
            else if (!emailPattern.test(params.target.value)) {
                setValidation({
                    ...validation,
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Enter a valid Notification email address"
                });
            }
            else {
                setValidation({
                    ...validation,
                    isNotificationEmailValid: false,
                    notificationEmailErrorMessage: "Notification Email Should not be more than 50 character "
                });
            }
        }
    }

    //function sleep(ms) {
    //    return new Promise(resolve => setTimeout(resolve, ms));
    //}
    function checkPreviousStage() {
        updOrgData();
        if ((prevStage === "SUSPEND" && rowDataSelected.currentStatus !== "SUSPEND") ||
            (prevStage === "SUSPENDED" && rowDataSelected.currentStatus !== "SUSPENDED"))
        {
            setShow(false);
            setJobEnableWarning(true);
        }
    }

    async function updOrgData() {

        
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                UserName: sessionStorage.getItem("UserName"),
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },

        };
        if (activeTabRef.current === "operations") {

            if (validation.isOrgValid && validation.isGoCardlessValid && validation.isXeroIdValid && validation.isSalesSourceValid && validation.isTrialDateValid && validation.isAdminEmailValid && validation.isNotificationEmailValid && validation.isSectorValid && rowDataSelected.resellerName) {
                setOperationFilter(gridApiRef.current.getFilterModel());
               // setOperationSorting(JSON.stringify(gridApiRef.columnApi.getColumnState()));
                setTableRefresh(true); 
                let selpriceModelID = priceModelsData.find(model => model.name === rowDataSelected.priceModel);
                let payload = {
                    resellerName: rowDataSelected.resellerName,
                    resellerId: rowDataSelected.resellerId,
                    orgName: rowDataSelected.orgName,
                    currentStatus: rowDataSelected.currentStatus,
                    nextAction: rowDataSelected.nextAction,
                    orgId: rowDataSelected.orgId,
                    priceModelID: selpriceModelID.id,
                    priceModelIDSpecified: true,
                    goCardlessID: rowDataSelected.goCardlessID,
                    xeroID: rowDataSelected.xeroID,
                    salesSource: rowDataSelected.salesSource,
                    adminEmail: rowDataSelected.adminEmail,
                    notificationEmail: rowDataSelected.notificationEmail,
                    cwCompanyID: rowDataSelected.cwCompanyID,
                    cwAgreementID: rowDataSelected.cwAgreementID,
                    trialUntil: moment(rowDataSelected.trialUntil, "DD-MM-YYYY").format("MM-DD-YYYY"),
                    nextActionDate: moment(rowDataSelected.nextActionDate, "DD-MM-YYYY").format("MM-DD-YYYY"),
                    sector: rowDataSelected.sector,
                };


                await Axios.post(API_ROUTE + Routes.UPDATE_ORG, payload, config)
                    .then((response) => {

                        if (response.data) {
                            showToast("error", response.data);
                        }

                    })
                    .catch((reason) => {
                        if (reason) {
                            showToast("error", reason);
                        }
                        else if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
                setShow(false);
                getResellerOrgs(rowDataSelected.orgId, true);
                // setTableRefresh(false);
                

            }
            else {
                if (rowDataSelected.orgName === "") {
                    showToast("error", "Organization Name should not be empty")
                }
                else if (rowDataSelected.orgName.length >200) {
                    
                    showToast("error", "Organization Name should not be more the 200 character")
                } else if (rowDataSelected.resellerName === ""|| rowDataSelected.trialUntil === "----") {
                    
                    showToast("error", "Reseller Name should not be empty. Please select a Reseller Name.")
                }
                else if (rowDataSelected.trialUntil === "") {
                    showToast("error", "Trial Date should not be empty")
                }
                //else if (rowDataSelected.currentStatus === "" || rowDataSelected.currentStatus === "----") {
                //    showToast("error", "Please select a valid stage")
                //}
                else {
                    showToast("error", "Please correct the validation issues")
                }
            }
        }

        if (activeTabRef.current === "reseller") {
          
            if (validation.isResellerNameValid && validation.isTelephoneNumberValid && validation.isPortalUrlValid && validation.isResellerTenantValid && validation.isOrgIdValid && validation.isResellerEmailValid && validation.isServerPathValid) {
                setResellerFilter(gridApiRefReseller.current.getFilterModel());
                //setResellerSorting(gridApiRefReseller.current.getSortModel());
                setTableRefresh(true);
                let priceModelID = priceModelsData.find(model => model.name === rowDataSelected.priceModelName);
                let payload = {
                    orgID: rowDataSelected.orgID,
                    resellerName: rowDataSelected.resellerName,
                    resellerId: rowDataSelected.resellerId,
                    resellerTelNo: rowDataSelected.resellerTelNo,
                    resellerURL: rowDataSelected.resellerURL,
                    resellerEmail: rowDataSelected.resellerEmail,
                    resellerPriceModel: priceModelID.id,
                    serverPath: rowDataSelected.serverPath,
                    tenentName: rowDataSelected.tenentName,
                    resellerIdSpecified: rowDataSelected.resellerIdSpecified,
                    resellerPriceModelSpecified: rowDataSelected.resellerPriceModelSpecified,
                    customModelsOnly: rowDataSelected.customModelsOnly
                };

                await Axios.post(API_ROUTE + Routes.UPDATE_RESELLER, payload, config)
                    .then((response) => {
                        if (response && response.data && response.data) {
                            showToast("error", response.data);
                        }


                    })
                    .catch((reason) => {
                        if (reason) {
                            showToast("error", reason);
                        }
                        else if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
                setShow(false);
                getResellerOrgs(null, true);
                gridApiRef.current.setFilterModel();
            }
            else {
                    showToast("error", "Please correct the validation issues")
                }
            }


    }



    const handleShow = (params) => {


        setRowDataSelected(params.data);
        setPrevStage(params.data.currentStatus)
        setValidation({
            ...validation,
            isOrgValid: true,
            orgErrorMessage: "",
            isResellerNameValid: true,
            resellerNameErrorMessage: "",
            isTelephoneNumberValid: true,
            telephoneNumberErrorMessage: "",
            isPortalUrlValid: true,
            portalUrlErrorMessage: "",
            isResellerTenantValid: true,
            resellerTenantErrorMessage: "",
            isOrgIdValid: true,
            orgIdErrorMessage: "",
            isResellerEmailValid: true,
            resellerEmailErrorMessage: "",
            isTrialDateValid: true,
            trailDateErrorMessage: ""
        });

        // Parse the contractStartDate string using Moment.js
        //const contractStartDate = moment(params.data.contractStart, 'MM/DD/YYYY hh:mm:ss A').toDate();

        // Update the state
        /* setRowDataSelected({
             ...rowDataSelected,
              contractDate: contractStartDate
         });*/


        setShow(true)
    };



    
    async function suspendOrg(params) {
        try {
            const confirmSuspension = window.confirm("Are you sure you want to suspend this Organisation?");

            if (confirmSuspension) {
                setOperationFilter(gridApiRef.current.getFilterModel());
              //  setOperationSorting(gridApiRef.current.getSortModel());
                setTableRefresh(true);

                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const inputData = {
                    resellerID: sessionStorage.getItem("ResellerID") ? decryptParameter(sessionStorage.getItem("ResellerID")) : "",
                    status: "SUSPENDED",
                    orgId: params.data.orgId,
                    OrgName:params.data.orgName,
                    // Token: tokenString,
                    username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",

                };

                await Axios.post(API_ROUTE + Routes.CHANGE_ORG_STATUS, inputData, config)
                    .then((response) => {
                        //let responsedata = response.data;
                        if (response.data) {
                            showToast("error", response.data);
                        }

                    });
                //  setOrgId(params.data.orgId);
                //setRefreshPage(!refreshPage);
                getResellerOrgs(params.data.orgId, true);
            }
        }
        catch (error) { console.log(error); }


    };
    async function activateOrg(params) {
        try {
            const confirmActivate = window.confirm("Are you sure you want to activate this Orgainisation?");
            const prevStatus = params.data.currentStatus;
            if (confirmActivate) {
                setOperationFilter(gridApiRef.current.getFilterModel());
               // setOperationSorting(gridApiRef.current.getSortModel());
                setTableRefresh(true);

                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const inputData = {
                    resellerID: sessionStorage.getItem("ResellerID") ? decryptParameter((sessionStorage.getItem("ResellerID"))) : "",
                    status: "LIVE",
                    orgId: params.data.orgId,
                    
                    OrgName: params.data.orgName,
                    // Token: tokenString,
                    username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",

                };

                await Axios.post(API_ROUTE + Routes.CHANGE_ORG_STATUS, inputData, config)
                    .then((response) => {
                        if (response.data) {
                            showToast("error", response.data);
                        }
                        if ((prevStatus === "SUSPEND") || (prevStatus === "SUSPENDED")) {
                            setJobEnableWarning(true);
                        }

                    }).catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }

                    });

            }
            // setOrgId(params.data.orgId);
            //setRefreshPage(!refreshPage);
            getResellerOrgs(params.data.orgId, true);
        }
        catch (error) { }


    };
    async function deleteOrg(params) {
        try {
            const delOrg = window.confirm("THIS WILL REMOVE THIS TENANT, OK TO CONTINUE?");

            if (delOrg) {
                setOperationFilter(gridApiRef.current.getFilterModel());
               // setOperationSorting(gridApiRef.current.getSortModel());
                setTableRefresh(true);
                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const inputData = {
                    OrgId: params.data.orgId
                 };

                await Axios.post(API_ROUTE + Routes.DELETE_ORG, inputData, config)
                    .then((response) => {
                        if (response.data && response.data !== "Deleted") {
                            showToast("error", response.data);
                        }
                    }).catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }

                    });
                getResellerOrgs(null, false,true);
            }

        }
        catch (error) { }


    };
    async function writeLog(orgName,orgId) {
        


        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        const inputData = {
            EventType: "INFO",
            PublicView:false,
            EventDetail: "Managed Org - " + orgName,
            EventSource: "MASTERADM",
            EventUser: sessionStorage.getItem("UserName"),
            OrgID: orgId,

        };

        await Axios.post(API_ROUTE + Routes.WRITE_LOG, inputData, config)
            .then((response) => {
                if (response.data) {

                   
                }

            });

    }
    async function handleTenantSummary(params) {
        var orgId = params.data.orgId
        var orgName = params.data.orgName
        var url = '/TenantSummary?orgId=' + orgId + '&orgName=' + orgName +'&masterAdmin=true'
        setTenantSummaryURL(url)
        setShowTenantSummary(true)
    }

    async function manageOrg(params) {
        try {
            const manageorg = window.confirm("Only manage if you have permision to do so. Ask the Organisation first.");
           
            if (manageorg) {
           
                sessionStorage.setItem('ManageOrgId', params.data.orgId);
                sessionStorage.setItem('ManageOrgName', params.data.orgName);
                sessionStorage.setItem('ManageTenantDomain', params.data.tennantDomain);
                sessionStorage.setItem('GuardianOnlyEnabled-' + params.data.orgId, !(params.data.m365Enabled.toString() === "true"));

                ////setManagedOrgId(sessionStorage.getItem('ManageOrgId'));
                ////setManagedOrgName(sessionStorage.getItem('ManageOrgName'));
                await writeLog(params.data.orgName, params.data.orgId);
                window.location.href = "/main?orgId=" + params.data.orgId + "&orgName=" + params.data.orgName;
            }

        }
        catch (error) { }


    };
    async function deleteRepo(params) {
        try {
            const savedFilterModel = gridApiPlatform.current.getFilterModel();
            setPlatformFilter(gridApiPlatform.current.getFilterModel());
            setTableRefresh(true); 

            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                },
            };
            console.log(params);
            const inputData = {
               
                repositoryId: params.data.repositoryId,
                //objectStorageId: params.data.objectStorageId
            };

            await Axios.post(API_ROUTE + Routes.DELETE_REPO_BACKUP, inputData, config)
                .then((response) => {
                    if (response.data) {

                        showToast("success", response.data);
                    }

                }).catch((reason) => {
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }

                });;
            fetchPlatformData(true);
            gridApiRef.current.setFilterModel(savedFilterModel);
        }
        catch (error) { }


    };
    

    async function deleteReseller(params) {
        try {
            const delReseller = window.confirm("Are you sure you want to delete this reseller record?");

            if (delReseller) {
                setResellerFilter(gridApiRefReseller.current.getFilterModel());
               // setResellerSorting(gridApiRefReseller.current.getSortModel());
                setTableRefresh(true);
                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };

                const inputData = {
                    ...params.data
                };

                await Axios.post(API_ROUTE + Routes.DELETE_RESELLER, inputData, config)
                    .then((response) => {
                        if (response.data) {

                            showToast("error", response.data);
                        }

                    }).catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }

                    });;
                getResellerOrgs(null, false,true);
            }
        }
        catch (error) { }
    };
    async function convertToReseller(params) {
        try {
            const convertToReseller = window.confirm("Are you sure you want to convert this orgainisation to a reseller?");
            const savedFilterModel = gridApiRef.current.getFilterModel();
            if (convertToReseller) {
                setOperationFilter(gridApiRef.current.getFilterModel());
               // setOperationSorting(gridApiRef.current.getSortModel());
                setTableRefresh(true);
                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };

                const inputData = {
                    ...params.data

                };

                await Axios.post(API_ROUTE + Routes.CONVERT_ORG_TO_RESELLER, inputData, config)
                    .then((response) => {
                        if (response.data) {
                            showToast("error", response.data);
                        }

                    }).catch((reason) => {
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }

                    });

            }
            getResellerOrgs(null, false,true);
            gridApiRef.current.setFilterModel(savedFilterModel);
        }
        catch (error) { }

    };

    const fetchStatusData = async () => {
        try {
            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const inputData = {
                ServerPath: sessionStorage.getItem('ServerPath') ? decryptParameter((sessionStorage.getItem('ServerPath'))) : "",
                ResellerID: sessionStorage.getItem("ResellerID") ? decryptParameter((sessionStorage.getItem("ResellerID"))) : "",
                Orderby: "ResellerName",

                Username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",
               


            };
            const resellerOrgs = await getItem('ResellerOrgs');
            const response = await Axios.post(API_ROUTE + Routes.GET_MA_RESELLER_ORG_STATUS, inputData, config);
            if (response) {
                console.log(response);
            }
           
            if (response && response.data ) {
                const responsedata = response.data.resellers;
                setRowData(prevRowData => {
                
                    const updatedRowData = JSON.parse(resellerOrgs);
                    responsedata.forEach((reseller) => {
                        const matchingRecordIndex = updatedRowData.findIndex(
                            (prevReseller) => prevReseller.orgId === reseller.orgId
                        );
                        if (matchingRecordIndex !== -1) {
                            updatedRowData[matchingRecordIndex].lastBackup = reseller.lastBackup;
                            updatedRowData[matchingRecordIndex].lastBackupStatus = reseller.lastBackupStatus;
                            updatedRowData[matchingRecordIndex].warningCount = reseller.warningCount;
                            updatedRowData[matchingRecordIndex].warningSplitUpMsg = reseller.warningSplitUpMsg;
                        }
                    });
                    setItem('ResellerOrgs', JSON.stringify(updatedRowData));
                  
                    return updatedRowData;
                });


            }
        } catch (error) {
            console.error("Error fetching status data:", error);
        }
    };
    const fetchPlatformData = async (isPlatformRefresh) => {
        try
        {
            if (sessionStorage.getItem('lastUpdateTime')) {


                const lastUpdateTime = parseInt(sessionStorage.getItem('lastUpdateTime'), 10);
                const currentTime = new Date().getTime();
                if ((currentTime - lastUpdateTime) >= (10 * 60 * 1000)) {
                    isPlatformRefresh = true;
                }
            }
            
            const platform = await getItem('PlatformData');
            if (!platform || isPlatformRefresh) {
               var tokenString = await setAuthContext("", new Date());

               const config = {
                   headers: {
                       Authorisation: `Bearer ` + tokenString,
                       CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                   },
               };
               
                const updatedData = await getItem('ResellerOrgs');
                const response = await Axios.get(API_ROUTE + Routes.GET_JOB_LIST + "/" + sessionStorage.getItem('orgId'), config);
               if (response && response.data ) {
                   const responsedata = response.data;
                   const updatedRowData = JSON.parse(updatedData);
                   if (updatedRowData && Array.isArray(updatedRowData)) {
                       responsedata.forEach((job) => {
                           const matchingRecordIndex = updatedRowData.findIndex(
                               (prevReseller) => prevReseller.orgId === job.orgId
                           );
                           if (matchingRecordIndex !== -1) {
                               job.orgName = updatedRowData[matchingRecordIndex].orgName;
                               job.resellerName = updatedRowData[matchingRecordIndex].resellerName;
                               job.m365Enabled = updatedRowData[matchingRecordIndex].m365Enabled;
                               job.currentStatus = updatedRowData[matchingRecordIndex].currentStatus;
                           }

                       });
                   }
                   setItem('PlatformData', JSON.stringify(responsedata));
                   setPlatformData(responsedata);
                   setTableRefresh(false);
               } 
           }
           else
           {
                //setPlatformData(JSON.parse(getItem('PlatformData')));
                const data = await getItem('PlatformData');
                setPlatformData(JSON.parse(data));
                setTableRefresh(false);
           }
        } 
        catch (error)
        {
            setTableRefresh(false);
            console.error("Error fetching status data:", error);
        }
       
    };

    const fetchGuardianData = async (isGuardianRefresh) => {
        try {
            if (sessionStorage.getItem('lastUpdateTime')) {


                const lastUpdateTime = parseInt(sessionStorage.getItem('lastUpdateTime'), 10);
                const currentTime = new Date().getTime();
                if ((currentTime - lastUpdateTime) >= (10 * 60 * 1000)) {
                    isGuardianRefresh = true;
                }
            }
            if (!sessionStorage.getItem('Guardian') || isGuardianRefresh) {
                var tokenString = await setAuthContext("", new Date());

                const config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                const response = await Axios.get(API_ROUTE + Routes.GET_ALL_GUARDIAN_JOBS, config);
              
                if (response && response.data) {
                    const responsedata = response.data;                    
                    sessionStorage.setItem('Guardian', JSON.stringify(responsedata));
                    setGuardianData(responsedata);
                    setTableRefresh(false);
                }
            }
            else {
                setGuardianData(JSON.parse(sessionStorage.getItem('Guardian')));
                setTableRefresh(false);
            }
        }
        catch (error) {
            setTableRefresh(false);
            console.error("Error fetching status data:", error);
        }

    };
    async function getResellerOrgs(fetchOrgId, fromCache, isRefresh) {
        // Flag to track component mount state
        try {


            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_COMPANIES, config)
                .then((response) => {

                    if (response && response.data) {
                        let responsedata = response.data;

                        setCompanies(responsedata);

                    }

                })
                .catch((reason) => {

                    console.error("error getResellerOrgs ", reason)
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

            await Axios.get(API_ROUTE + Routes.GET_CONNECTWISE_AGREEMENTS, config)
                .then((response) => {

                    if (response && response.data) {
                        let responsedata = response.data;
                        setAgreements(responsedata);

                    }

                })
                .catch((reason) => {
                    if (reason?.response?.status === 403) {
                        window.location.href = "/Unauthorized";
                    }
                    else if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler"; // Redirect on 401
                    }

                });

            const inputData = {
                ServerPath: sessionStorage.getItem('ServerPath') ? decryptParameter((sessionStorage.getItem('ServerPath'))) : "",
                ResellerID: sessionStorage.getItem("ResellerID") ? decryptParameter((sessionStorage.getItem("ResellerID"))) : "",
                Orderby: "ResellerName",

                Username: sessionStorage.getItem("Username") ? decryptParameter(sessionStorage.getItem("Username")) : "",
                OrgId: fetchOrgId,


            };
            if (sessionStorage.getItem('lastUpdateTime')) {

              
                const lastUpdateTime = parseInt(sessionStorage.getItem('lastUpdateTime'), 10) ;
                const currentTime = new Date().getTime();
                if ((currentTime - lastUpdateTime) >= (10 * 60 * 1000)) {

                    //If time is more than 10mins clear the cachevalues;
                    fromCache = false;
                    isRefresh = true;
                }

            }
            if (fromCache) {


                await Axios.post(API_ROUTE + Routes.GET_MA_RESELLER_ORG_CACHE, inputData, config)
                    .then((response) => {

                        let responsedata = response.data;

                        setRowData(prevRowData => {
                            const updatedRowData = [...prevRowData];
                            responsedata.forEach((reseller) => {
                                const matchingRecordIndex = updatedRowData.findIndex(
                                    (prevReseller) => prevReseller.orgId === reseller.orgId
                                );
                                if (matchingRecordIndex !== -1) {
                                    reseller.lastBackup = updatedRowData[matchingRecordIndex].lastBackup;
                                    reseller.lastBackupStatus = updatedRowData[matchingRecordIndex].lastBackupStatus;
                                    reseller.warningCount = updatedRowData[matchingRecordIndex].warningCount;
                                    reseller.warningSplitUpMsg = updatedRowData[matchingRecordIndex].warningSplitUpMsg;
                                    updatedRowData[matchingRecordIndex] = reseller;
                                }
                            });
                            setItem('ResellerOrgs', JSON.stringify(updatedRowData))
                            return updatedRowData;
                        });


                    })
                    .catch((reason) => {
                        if (reason?.response?.status === 403) {
                            window.location.href = "/Unauthorized";
                        }
                        else if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }

                    });

                await Axios.post(API_ROUTE + Routes.GET_MASTERADMIN_RESELLERS, "", config)
                    .then((response) => {
                        if (response) {
                            console.log(response);
                        }
                        let responsedata = response.data;
                        setItem('Resellers', JSON.stringify(responsedata))
                        setResellersData(responsedata);



                    })
                    .catch((reason) => {
                        if (reason?.response?.status === 403) {
                            window.location.href = "/Unauthorized";
                        }
                        else if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }

                    });
            }
            else {
                const resellers = await getItem('Resellers');
                const resellerOrgs = await getItem('ResellerOrgs');
                if (isRefresh === true || !(resellerOrgs && resellers))
                //  if (isRefresh === true )
                {

                    await Axios.post(API_ROUTE + Routes.GET_MA_RESELLER_ORG, inputData, config)
                        .then((response) => {

                            let responsedata = response.data;
                            let data = (responsedata.resellers) ? responsedata.resellers : null;
                            setItem('ResellerOrgs', JSON.stringify(data))
                            setRowData(data);


                            setOrgStatuses(responsedata.orgStatuses);
                            setItem('OrgStatuses', JSON.stringify(responsedata.orgStatuses));

                            setSectors(responsedata.sectors);
                            setItem('Sectors', JSON.stringify(responsedata.sectors));

                            setPriceModelsData(responsedata.priceModels)
                            setItem('PriceModels', JSON.stringify(responsedata.priceModels));

                            const currentDateTime = new Date().getTime(); // Get current datetime in milliseconds
                            sessionStorage.setItem('lastUpdateTime', currentDateTime);
                            fetchStatusData();
                        })
                        .catch((reason) => {
                            if (reason?.response?.status === 403) {
                                window.location.href = "/Unauthorized";
                            }
                            else if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });

                    await Axios.post(API_ROUTE + Routes.GET_MASTERADMIN_RESELLERS, "", config)
                        .then((response) => {

                            let responsedata = response.data;

                            setItem('Resellers', JSON.stringify(responsedata));
                            setResellersData(responsedata);




                        })
                        .catch((reason) => {
                            if (reason?.response?.status === 403) {
                                window.location.href = "/Unauthorized";
                            }
                            else if (reason?.response?.status === 440) {
                                window.location.href = "/TimeoutErrorHandler";
                            }
                        });
                }
                else {

                    const orgStatusesJson = await getItem('OrgStatuses');
                    const priceModelsJson = await getItem('PriceModels');
                    const sectorsJson = await getItem('Sectors');
                    setRowData(JSON.parse(resellerOrgs));
                    setResellersData(JSON.parse(resellers));
                    setOrgStatuses(JSON.parse(orgStatusesJson));
                    setSectors(JSON.parse(sectorsJson));
                    setPriceModelsData(JSON.parse(priceModelsJson));

                }
            }

            // Cleanup function to run when the component is unmounted



        }
        catch (error) { console.log(error); }
        setTableRefresh(false);

    }
    useEffect(() => {
        getResellerOrgs(null, false, false);
        fetchPlatformData(false);
        fetchGuardianData(false);
    }, []);




    useEffect(() => {
        // Your code

        activeTabRef.current = activeTab;

        //}, [activeTab, resellersData, orgStatuses, priceNodelsData]);


    }, [activeTab]);



    const handleStatusChange = (params) => {

        //if (value === "" || value === "----") {
        //    setValidation({
        //        ...validation,
        //        isStageValid: false,
        //    });
        //}
        //else {
        //    setValidation({
        //        ...validation,
        //        isStageValid: true,
        //    });
        //}
        setRowDataSelected({
            ...rowDataSelected,


            currentStatus: params.target.value

        });

    };

    useEffect(() => {

        if (rowDataSelected) {
            if (activeTabRef.current === "operations") {


                setModalBody(
                    <>
                        <Row>
                            <Col>
                                <Form>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                <Form.Label>Reseller Name</Form.Label>

                                            <Form.Select value={rowDataSelected.resellerName}
                                                onChange={resellerChange}>
                                                    <option value="">----</option>
                                                    {
                                                        resellersData?.sort((a, b) => a.resellerName.localeCompare(b.resellerName))
                                                            .map(reseller => (
                                                                <option key={reseller.resellerId} value={reseller.resellerName}>
                                                                    {reseller.resellerName}
                                                                </option>
                                                            ))
                                                    }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Stage</Form.Label>

                                            <Form.Select value={trim(rowDataSelected.currentStatus)}
                                                    onChange={handleStatusChange}
                                            > 
                                                    {/*<option value="">----</option>*/}
                                                    {
                                                        orgStatuses && Array.isArray(orgStatuses) && orgStatuses
                                                            //.filter(result => {
                                                            //if (rowDataSelected.resellerId > 1) {
                                                            //    return result.reseller === "1";
                                                            //}
                                                            //return true;
                                                            //})
                                                            .map((sts) => (
                                                            <option key={sts.id} value={sts.status}>
                                                                {sts.status}
                                                            </option>
                                                        ))
                                                    }
                                                </Form.Select>
                                            </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Sales Source</Form.Label>
                                            <Form.Control type="text" placeholder="Sales Source" isInvalid={!validation.isSalesSourceValid} value={rowDataSelected.salesSource} onChange={saleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {validation.salesSourceErrorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.Go">
                                            <Form.Label>Trial Date</Form.Label>
                                                <Form.Control type="date" isInvalid={!validation.isTrialDateValid}  value={moment(rowDataSelected.trialUntil, "DD-MM-YYYY").format("YYYY-MM-DD")} onChange={trailDateChange} />
                                            <Form.Control.Feedback type="invalid">
                                                    {validation.trailDateErrorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.xer">
                                            <Form.Label>Xero ID</Form.Label>
                                            <Form.Control type="text" placeholder="Xero ID" isInvalid={!validation.isXeroIdValid} value={rowDataSelected.xeroID} onChange={xeroIDChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {validation.xeroIdErrorMessage}
                                            </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.CWID">
                                                <Form.Label>CW Company ID</Form.Label>

                                                <Form.Select value={rowDataSelected.cwCompanyID}
                                                    onChange={cwCompanyIDChange}
                                                >
                                                    {rowDataSelected.cwCompanyID === 0 && (
                                                        <option value="0">----</option>
                                                    )}
                                                    {
                                                        companies && Array.isArray(companies) && companies.map((company) => (
                                                            <option key={company.id} value={company.id}>
                                                                {company.name}
                                                            </option>
                                                        ))
                                                    }
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {validation.cwCompanyIdErrorMessage}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.CWAGID">
                                                <Form.Label>CW Agreement ID</Form.Label>

                                                <Form.Select value={rowDataSelected.cwAgreementID}
                                                    onChange={cwAggreementIDChange}
                                                >
                                                    {rowDataSelected.cwAgreementID === 0 && (
                                                        <option value="0">----</option>
                                                    )}
                                                    {

                                                        rowDataSelected.cwCompanyID && rowDataSelected.cwCompanyID >0 && agreements && Array.isArray(agreements) && agreements
                                                            .filter(agreement => agreement.company.id === rowDataSelected.cwCompanyID) // Filter agreements based on selected company ID
                                                            .map((filteredAgreement) => (
                                                                <option key={filteredAgreement.id} value={filteredAgreement.id}>
                                                                    {filteredAgreement.name}
                                                                </option>
                                                            ))
                                                    }
                                                </Form.Select>
                                               
                                                <Form.Control.Feedback type="invalid">
                                                    {validation.cwAggreementIdErrorMessage}
                                                </Form.Control.Feedback>   </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Organisation Name</Form.Label>
                                            <Form.Control type="text" isInvalid={!validation.isOrgValid} placeholder="Organisation Name" value={rowDataSelected.orgName} onChange={orgChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {validation.orgErrorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Next Action</Form.Label>
                                            <Form.Select value={trim(rowDataSelected.nextAction)}
                                                onChange={nextActionChange}>
                                                {
                                                        orgStatuses && Array.isArray(orgStatuses) && orgStatuses
                                                            //.filter(result => {
                                                            //if (rowDataSelected.resellerId > 1) {
                                                            //    return result.reseller === "1";
                                                            //}
                                                            //return true;
                                                            //})
                                                            .map((sts) => (
                                                            <option key={sts.id} value={sts.status}>
                                                                {sts.status}
                                                            </option>
                                                        ))
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3" >
                                                <Form.Label>Next Action Date</Form.Label>
                                                <Form.Control type="date" isInvalid={!validation.isNextActionDateValid} value={moment(rowDataSelected.nextActionDate, "DD-MM-YYYY").format("YYYY-MM-DD")} onChange={nextActionDateChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {validation.trailDateErrorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.Selectprice"  >
                                            <Form.Label>Packages</Form.Label>
                                            <Form.Select value={rowDataSelected.priceModel}
                                                onChange={priceModelChange}>

                                                {
                                                        priceModelsData && Array.isArray(priceModelsData) &&

                                                        priceModelsData.map((sts) => (!sts.nonSelectable || rowDataSelected.priceModel.trim() === sts.name.trim()) && 
                                                            <option key={sts.id} value={sts.name}>
                                                                {sts.name}
                                                            </option>
                                                        )
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.Go">
                                            <Form.Label>GoCardless IDs</Form.Label>
                                            <Form.Control type="text" placeholder="GoCardless ID" isInvalid={!validation.isGoCardlessValid} value={rowDataSelected.goCardlessID} onChange={goCardlessIDChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {validation.goCardLessErrorMessage}
                                            </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>Admin Email</Form.Label>
                                                <Form.Control type="text" placeholder="Admin Email" isInvalid={!validation.isAdminEmailValid} value={rowDataSelected.adminEmail} onChange={adminEmailChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validation.admilEmailErrorMessage}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                <Form.Label>Notification Email</Form.Label>
                                                <Form.Control type="text" placeholder="Notification Email" isInvalid={!validation.isNotificationEmailValid} value={rowDataSelected.notificationEmail} onChange={notificationEmailChange} />
                                                <Form.Control.Feedback type="invalid">
                                                    {validation.notificationEmailErrorMessage}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group className="mb-3" >
                                                <Form.Label>Sector</Form.Label>
                                                <Form.Select
                                                    value={rowDataSelected.sector || ""}
                                                    onChange={sectorChange}
                                                    isInvalid={!validation.isSectorValid}
                                                >
                                                    <option value="">-- Select Sector --</option>
                                                    {sectors.map((sector) => (
                                                        <option key={sector} value={sector}>
                                                            {sector}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                    </Col>
                                    </Row> 
                                </Form>
                            </Col>
                        </Row>

                    </>)
            }
            else if (activeTabRef.current === "reseller") {

                setModalBody(
                    <Row>
                        <Col>
                            <Form>

                                < Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Reseller Name</Form.Label>
                                    <Form.Control type="text" placeholder="Reseller Name" isInvalid={!validation.isResellerNameValid} value={rowDataSelected.resellerName} onChange={resellerChangeinReseller} />
                                    <Form.Control.Feedback type="invalid">
                                        {validation.resellerNameErrorMessage}
                                    </Form.Control.Feedback>
                                </Form.Group>


                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Telephone No</Form.Label>
                                    <Form.Control type="text" placeholder="Telephone No" isInvalid={!validation.isTelephoneNumberValid} value={rowDataSelected.resellerTelNo} onChange={telphoneChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {validation.telephoneNumberErrorMessage}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Portal URL</Form.Label>
                                    <Form.Control type="text" placeholder="Portal URL" isInvalid={!validation.isPortalUrlValid} value={rowDataSelected.resellerURL} onChange={resellerURLChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {validation.portalUrlErrorMessage}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Reseller Tenant</Form.Label>
                                    <Form.Control type="text" placeholder="Reseller Tenant" isInvalid={!validation.isResellerTenantValid} value={rowDataSelected.tenentName} onChange={tennantDomainChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {validation.resellerTenantErrorMessage}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Org ID</Form.Label>
                                    <Form.Control type="text" placeholder="Org ID" isInvalid={!validation.isOrgIdValid} value={rowDataSelected.orgID} onChange={resellerOrgIdChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {validation.orgIdErrorMessage}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1.Selectprice"  >
                                    <Form.Label>Packages</Form.Label>
                                    <Form.Select value={rowDataSelected.priceModelName}
                                        onChange={resellerPriceModelChange}>

                                        {
                                            priceModelsData && Array.isArray(priceModelsData) &&

                                            priceModelsData.map((sts) => (!sts.nonSelectable || rowDataSelected.priceModelName === sts.name) &&
                                                <option key={sts.id} value={sts.name}>
                                                    {sts.name}
                                                </option>
                                            )
                                        }
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="text" placeholder="Email" isInvalid={!validation.isResellerEmailValid} value={rowDataSelected.resellerEmail} onChange={resellerEmailChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {validation.resellerEmailErrorMessage}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="row">
                                    <div className="col">
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                            <Form.Label>Server Path</Form.Label>
                                            <Form.Control type="text" placeholder="Server Path" isInvalid={!validation.isServerPathValid} value={rowDataSelected.serverPath} onChange={serverPathChange} />
                                            <Form.Control.Feedback type="invalid">
                                                {validation.ServerPathErrorMessage}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col d-flex align-items-start">
                                        <Form.Group className="mb-3" style={{marginTop:'1.8rem'}}>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input ms-3" checked={rowDataSelected.customModelsOnly} onChange={customModelsOnly} />
                                                <label title="Custom models only" className="form-check-label mt-1 ms-2">Custom models only</label>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                                
                            </Form>
                        </Col>
                    </Row>
                )
            }

        }


    }, [rowDataSelected]);
    const gridApiRef = useRef(null);
    
    const onGridReady = (params) => {
        // Get a reference to the grid API
        gridApiRef.current = params.api;
        gridApiRef.current.setFilterModel(operationFilter);
        gridApiRef.current.refreshClientSideRowModel('filter');
       /* if (operationSorting) {
            gridApiRef.current.columnApi.applyColumnState({ state: JSON.parse(operationFilter) });
            //      gridOptions.columnApi.applyColumnState({ state: parsedColumnState });
        }*/
    };

    

    const gridApiRefReseller = useRef(null);

    const onGridReadyReseller = (params) => {
        // Get a reference to the grid API
        gridApiRefReseller.current = params.api;
        gridApiRefReseller.current.setFilterModel(resellerFilter);
        gridApiRefReseller.current.refreshClientSideRowModel('filter');
       // gridApiRefReseller.current.setSortModel(resellerSorting);
    };

    const gridApiPlatform = useRef(null);
    const gridApiGuardian = useRef(null);
    const onGridReadyPlatform = (params) => {
      
        gridApiPlatform.current = params.api;
        gridApiPlatform.current.setFilterModel(platformFilter);
        gridApiPlatform.current.refreshClientSideRowModel('filter');
    
    };
    const onGridReadyGuardian = (params) => {
        
        gridApiGuardian.current = params.api;
        ////gridApiGuardian.current.setFilterModel(guardianFilter);
        gridApiGuardian.current.refreshClientSideRowModel('filter');
        gridApiGuardian.current.sizeColumnsToFit();
    };

    const handleClose = () => setShow(false);
    const handleTenantSummaryClose = () => setShowTenantSummary(false);
    const toInitCase = (str) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });


    };
    return (
        <>
            {loaded &&
                <NavBar page="masterAdmin" authContext={authContext} />}

            <div className=" p-1">

                <span className="SectionTitle primary_text">MASTER ADMINISTRATION PAGE CUSTOMER LIST &nbsp; &nbsp;
                    <a id="ContentPlaceHolder1_btnAddRep" style={{ color: "#007bff" }} href={"/SignUp"}><Button  variant="primary" className="me-2"> <i className="fas fa-plus"></i> Add Tenant</Button></a>
                    {/*<a id="ContentPlaceHolder1_btnAddRep1" style={{ color: "#007bff" }} href={"/GuardianSignUp"}><Button variant="primary" className="me-2"> <i className="fas fa-plus"></i> Add Guardian Tenant</Button></a>*/}
                    {/*<button id="MasterAdmin_btnDownload" style={{ color: "#007bff", cursor: 'pointer', position: 'relative', top: '2.5rem', float: 'inline-end' }} className="me-2 a-icon">*/}
                    <button id="MasterAdmin_btnDownload" style={{ color: "#007bff", cursor: 'pointer', position: 'relative', top: '2.5rem', float: 'inline-end' }} className="me-2 btn btn-primary"title="Download" onClick={(e) => {
                            if (activeTabRef.current === "operations") {
                                gridApiRef.current.exportDataAsCsv();
                                // gridApiRefs.operations.current.sizeColumnsToFit();
                            }
                            if (activeTabRef.current === "reseller") {
                                gridApiRefReseller.current.exportDataAsCsv();
                                // gridApiRefs.operations.current.sizeColumnsToFit();
                            }

                            if (activeTabRef.current === "platform") {
                                gridApiPlatform.current.exportDataAsCsv();
                                // gridApiRefs.operations.current.sizeColumnsToFit();
                            }
                            if (activeTabRef.current === "guardian") {
                                gridApiGuardian.current.exportDataAsCsv();
                               
                            }
                        }
                        } variant="primary">   <svg
                                className="svg-inline--fa fa-download fa-w-18 fa-lg"
                                style={{ color: 'white', fill: 'transparent', fontSize: '16px' }}
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="far"
                                data-icon="download"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512"
                            >
                                <path
                                    fill="currentColor"
                                    d="M528 288h-92.1l46.1-46.1c30.1-30.1 8.8-81.9-33.9-81.9h-64V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v112h-64c-42.6 0-64.2 51.7-33.9 81.9l46.1 46.1H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-400-80h112V48h96v160h112L288 368 128 208zm400 256H48V336h140.1l65.9 65.9c18.8 18.8 49.1 18.7 67.9 0l65.9-65.9H528v128zm-88-64c0-13.3 10.7-24 24-24s24 10.7 24 24-10.7 24-24 24-24-10.7-24-24z"
                                />
                            </svg></button>

                    {/*</button>*/}

                    <button id="ContentPlaceHolder1_btnClear" style={{ cursor: 'pointer', position: 'relative', top: '2.5rem', float: 'inline-end' }} className="me-1 a-icon">
                        <Button title="Clear Filter" onClick={(e) => {
                            if (activeTabRef.current === "operations") {
                                gridApiRef.current.setFilterModel(null);
                            }
                            if (activeTabRef.current === "reseller") {
                                gridApiRefReseller.current.setFilterModel(null);
                            }
                            if (activeTabRef.current === "platform") {
                                gridApiPlatform.current.setFilterModel(null);
                            }
                            if (activeTabRef.current === "guardian") {
                                gridApiGuardian.current.setFilterModel(null);
                            }
                        }
                        } variant="primary"> <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 32 32" width="20" style={{ cursor: 'pointer' }}>
                                <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                            </svg></Button>

                    </button>
               
                    {/*<button id="ContentPlaceHolder1_btnRefresh" className="me-1 a-icon" style={{ color: "#007bff", position: 'relative', top: '2.5rem', float: 'inline-end' }}>*/}
                    <button id="ContentPlaceHolder1_btnRefresh" className="me-1 btn btn-primary" style={{ color: "#007bff", cursor: 'pointer', position: 'relative', top: '2.5rem', float: 'inline-end' }} title="Refresh" onClick={(e) => {
                    
                        setTableRefresh(true);
                        getResellerOrgs(null, false, true);
                        fetchPlatformData(true);
                       fetchGuardianData(true);
                    }
                    } variant="primary"> <svg style={{ marginBottom: '.1rem' }} className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                            <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                            </path>
                            </svg> </button>
                    {/*</button>*/}

                   
                    <ColumnSelector onClose={handleColumnSelectorClose} isVisible={showColumnSelector}> </ColumnSelector>
                    {showColumnSelector &&
                        <Dropdown className="me-1" style={{ position: 'relative', top: '2.5rem', float: 'inline-end' }} autoClose="outside">
                            <Dropdown.Toggle variant="primary" id="ContentPlaceHolder1_btnGrid">
                                Default
                            </Dropdown.Toggle>
                            <Dropdown.Menu style={{ maxHeight: '61vh', overflowY: 'auto', padding: '0' }}>
                                <DefaultColumnSelector onClose={handleDefaultColumnSelector}> </DefaultColumnSelector>
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                </span>

            </div>

            <Tabs
                defaultActiveKey="operations"
                transition={false}
                activeKey={activeTab}
                onSelect={handleTabSelect}
                id="master-admin-tab"
            >
                <Tab eventKey="operations" title="Tenants">
                    <div className="ag-theme-alpine p-1" style={{ width: "100%", maxHeight: '77vh', borderCollapse: "collapse", height: '76vh' }}>
                        {activeTabRef.current === "operations" && tableRefresh ?
                            <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                    <img src={LoaderGif} alt="loading" style={{ height:'70px' }} />
                                <span className="visually-hidden">Loading...</span>
                            </div> :
                            <AgGridReact
                                rowData={rowData}
                                onGridReady={onGridReady}
                                enableCellTextSelection="true"
                                columnDefs={orgColumnDefs}
                                animateRows={true}
                                pagination={true}
                                rowBuffer={1000}
                                paginationPageSize={1000}
                                paginationPageSizeSelector={[20, 50, 100, 1000]}
                                overlayLoadingTemplate={
                                    `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                overlayNoRowsTemplate='<span className="ag-overlay-loading-center">No records to show</span>'

                            >
                            </AgGridReact>

                        }
                    </div>
                </Tab>
                <Tab eventKey="reseller" title="Reseller">
                    <div className="ag-theme-alpine p-1" style={{ borderStyle: "Solid", width: "100%", maxHeight: '77vh', borderCollapse: "collapse", height: '76vh' }}>
                        {activeTabRef.current === "reseller" && tableRefresh ?
                            <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                                <span className="visually-hidden">Loading...</span>
                            </div> :
                            <AgGridReact
                                rowData={resellersData}
                                onGridReady={onGridReadyReseller}  
                                enableCellTextSelection="true"
                                columnDefs={resellerDefs}
                                animateRows={true}
                                pagination={true}
                                paginationPageSize={1000}
                                paginationPageSizeSelector={[20, 50, 100, 1000]}
                                rowBuffer={1000}
                                overlayLoadingTemplate={`<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                                overlayNoRowsTemplate='<span className="ag-overlay-loading-center">No records to show</span>'
                            >
                            </AgGridReact>
                        }

                    </div>
                </Tab>
                {(!isVeeam365AdminSales || isVeeam365Admin || isVeeam365Engineer) && (
                <Tab eventKey="platform" title="Platform">
                    <div className="ag-theme-alpine p-1" style={{ borderStyle: "Solid", width: "100%", maxHeight: '77vh', borderCollapse: "collapse", height: '76vh' }}>
                        {activeTabRef.current === "platform" && tableRefresh ?
                            <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                                <span className="visually-hidden">Loading...</span>
                            </div> :
                            <AgGridReact
                                rowData={platformData}
                                onGridReady={onGridReadyPlatform}
                                enableCellTextSelection="true"
                                columnDefs={platformDefs}
                                animateRows={true}
                                pagination={true}
                                paginationPageSize={1000}
                                paginationPageSizeSelector={[20, 50, 100, 1000]}
                                rowBuffer={1000}
                                overlayLoadingTemplate={`<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                                overlayNoRowsTemplate='<span className="ag-overlay-loading-center">No records to show</span>'
                            >
                            </AgGridReact>
                        }

                        </div>
                    </Tab>
                )}
                {(!isVeeam365AdminSales || isVeeam365Admin || isVeeam365Engineer) && (
                    <Tab eventKey="guardian" title="Guardian Jobs">
                        <div className="ag-theme-alpine p-1" style={{ borderStyle: "Solid", width: "100%", maxHeight: '77vh', borderCollapse: "collapse", height: '76vh' }}>
                            {activeTabRef.current === "guardian" && tableRefresh ?
                                <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                    <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                                    <span className="visually-hidden">Loading...</span>
                                </div> :
                                <AgGridReact
                                    rowData={guardianData}
                                    onGridReady={onGridReadyGuardian}
                                    enableCellTextSelection="true"
                                    columnDefs={guardianDefs}
                                    animateRows={true}
                                    pagination={true}
                                    paginationPageSize={1000}
                                    paginationPageSizeSelector={[20, 50, 100, 1000]}
                                    rowBuffer={1000}
                                    onFirstDataRendered={(params) => {
                                        if (params && params.api) {
                                            params.api.sizeColumnsToFit();
                                        }
                                    }}
                                    onSelectionChanged={() => {
                                        if (gridApiGuardian.current) {
                                            gridApiGuardian.current.sizeColumnsToFit();
                                        }

                                    }}
                                    onGridSizeChanged={(params) => {
                                        if (params && params.api) {
                                            params.api.sizeColumnsToFit();
                                        }
                                    }}
                                    onModelUpdated={(params) => {
                                        if (params && params.api) {
                                            params.api.sizeColumnsToFit(); // Re-adjust column sizes
                                        }
                                    }}
                                    overlayLoadingTemplate={`<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><img src="${LoaderGif}" alt="loading" style="height:50px;"></div>`}
                                    overlayNoRowsTemplate='<span className="ag-overlay-loading-center">No records to show</span>'
                                >
                                </AgGridReact>
                            }

                        </div>
                    </Tab>
                )}
            </Tabs>
            <Modal show={show} onHide={handleClose} backdrop="static" size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{toInitCase(activeTab)} Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalBody}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={() => checkPreviousStage()} >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showTenantSummary} onHide={handleTenantSummaryClose} className="tenant-summary-popup">
                <Modal.Header closeButton>
                    <Modal.Title>Tenant Summary</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {/*<iframe src="https://localhost:44318/TenantSummary?orgId=a5e1325e-ab60-4ff0-b0fe-2ce3a90ccc4a&orgName=M365x92752860.onmicrosoft.com"*/}
                        <iframe src={tenantSummaryURL } sandbox="allow-scripts allow-same-origin"
                            style={{ height: "70vh", width: '100%', minWidth: "-webkit-fill-available" }} title="Tenant Summary"></iframe>
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal show={jobEnableWarning} onHide={handleClose} backdrop="static" size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Warning!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Jobs may have been paused whilst the organisation was suspended. please check for paused jobs.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setJobEnableWarning(false) }}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>

            {//<ToastContainer limit={4} style={{ fontSize: "small" }} />
            }
        </>
    );
}

export default MasterAdmin 